<div *ngIf="dataSource" fxLayout="column">
  <div *ngIf="title" class="title__sub-title">{{ title }}</div>

  <div fxFlex="100" fxLayout="column" class="table__content">
    <!-- Data -->
    <mat-card fxLayout="column" class="table__card">
      <mat-card-content fxLayout="column">
        <!-- Header -->
        <div
          fxFlex="100"
          fxLayout="row"
          class="table__header"
          fxLayoutAlign="space-between center"
        >
          <div fxLayoutAlign="start center" fxFlex="100">
            <ng-container *ngFor="let column of displayedColumns">
              <div
                *ngIf="!column.hidden && column.value !== 'check'"
                [fxFlex]="column.size"
                fxLayoutAlign="start center"
                class="fw_600"
              >
                {{ column.showValue }}
                <div fxLayout="column" *ngIf="column.orderBy">
                  <mat-icon
                    class="table__header__order table__header__order__up"
                    (click)="changeOrdination(column.value, 'ASC')"
                    >keyboard_arrow_up</mat-icon
                  >
                  <mat-icon
                    class="table__header__order table__header__order__down"
                    (click)="changeOrdination(column.value, 'DESC')"
                    >keyboard_arrow_down</mat-icon
                  >
                </div>
              </div>

              <div
                *ngIf="column.value === 'check'"
                [fxFlex]="column.size"
                fxLayoutAlign="start center"
                class="table__header__check-all"
                (click)="checkAll()"
                matTooltip="Marcar/Desmarcar Todos"
                matTooltipPosition="above"
              >
                <mat-icon class="table__header__check-all__icon"
                  >check</mat-icon
                >
              </div>
            </ng-container>
          </div>
          <div fxFlex="auto" *ngIf="tableActions?.length"></div>
        </div>

        <div class="table__data" fxLayout="column">
          <!-- <ngx-spinner
            bdColor="rgba(51,51,51,0.8)"
            size="medium"
            color="#fff"
            type="ball-spin-clockwise"
            name="pln-table"
            [fullScreen]="false"
          >
          </ngx-spinner> -->

          <!-- Exibe apenas quando não retornar registros -->
          <div
            fxFlex="100"
            fxLayout="row"
            fxLayoutAlign="space-between center"
            *ngIf="!dataSource?.data?.length"
            class="table__line"
          >
            <div fxFlex="100">Nenhum registro localizado</div>
          </div>

          <!-- Exibe listagem dos dados retornado -->
          <div
            fxFlex="100"
            fxLayout="row"
            fxLayoutAlign="start center"
            *ngFor="let data of dataSource?.data"
            class="table__line"
          >
            <ng-container *ngFor="let column of displayedColumns">
              <div
                [fxFlex]="column.size"
                *ngIf="!column.hidden && column.value === 'check'"
              >
                <mat-checkbox
                  class="table__line__check"
                  color="primary"
                  (change)="emitCheck($event, data)"
                  [checked]="verifyHasCheck(data)"
                ></mat-checkbox>
              </div>

              <div
                [fxFlex]="column.size"
                *ngIf="!column.hidden && column.value !== 'check'"
              >
                {{ data | plnTableValue : column }}
              </div>
            </ng-container>
            <div
              fxFlex="auto"
              fxLayout="row"
              fxLayoutAlign="center center"
              *ngFor="let action of tableActions"
            >
              <mat-icon
                class="icons material-icons-outlined"
                [matTooltip]="action.tooltip"
                matTooltipPosition="below"
                (click)="emitAction(action, data)"
                >{{ action.icon }}</mat-icon
              >
            </div>
          </div>
        </div>
      </mat-card-content>
      <mat-card-footer>
        <!-- Paginação -->
        <div
          fxFlex="100"
          fxFlex.lt-md="100"
          fxLayout="row"
          fxLayoutAlign="space-between center"
          fxLayoutAlign.lt-md="center"
          *ngIf="dataSource?.data?.length"
          class="pagination"
        >
          <!-- Setas -->
          <div fxLayoutAlign="start center" fxLayout="row" fxFlex="60">
            <div
              class="pagination__navigation"
              fxLayout="row"
              fxLayoutAlign="start center"
            >
              <div
                class="pagination__icon pagination__icon__arrow__left"
                [ngClass]="{
                  pagination__icon__arrow: currentPage > 1,
                  pagination__icon__arrow__disabled: currentPage <= 1
                }"
                fxLayoutAlign="center center"
                (click)="previousPage()"
              >
                <mat-icon> arrow_left </mat-icon>
              </div>

              <div
                fxLayoutAlign="center center"
                fxLayout="row"
                *ngFor="let page of pagesToShow"
                class="pagination__pages"
                [ngClass]="{
                  pagination__pages__current: page === currentPage
                }"
                (click)="goToPage(page)"
              >
                <div>
                  {{ page }}
                </div>
              </div>

              <div
                class="pagination__icon"
                [ngClass]="{
                  pagination__icon__arrow: currentPage < totalPages,
                  pagination__icon__arrow__disabled:
                    currentPage >= totalPages || !totalPages
                }"
                fxLayoutAlign="center center"
                (click)="nextPage()"
              >
                <mat-icon>arrow_right</mat-icon>
              </div>
            </div>
          </div>

          <div fxLayoutAlign="end center" fxLayout="row" fxFlex="20">
            {{ this.itemsPerPage * this.currentPage }} de
            {{ this.dataSource.totalItens }} registro(s)
          </div>
          <!-- Itens por página -->
          <div
            fxLayoutAlign="space-between center"
            fxLayout="row"
            fxFlex="20"
            class="pagination__navigation__limit"
          >
            <mat-form-field appearance="outline" fxFlex="100">
              <mat-select
                [(ngModel)]="itemsPerPage"
                (selectionChange)="changeItensPerPage()"
              >
                <mat-option
                  *ngFor="let itemToShow of itemsToShow"
                  [value]="itemToShow"
                >
                  {{ itemToShow }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </mat-card-footer>
    </mat-card>
  </div>
</div>
